import ViewWrapper from 'components/view-wrapper/view-wrapper.vue';
import InnerFrame from 'components/inner-frame/inner-frame';
import RouteBuilder from './routeBuilder';

let infoBuilder = new RouteBuilder('jiujing', ViewWrapper, InnerFrame);
let infoRoutes = RouteBuilder.buildMyInfo(infoBuilder, true);
export default infoRoutes;


// WEBPACK FOOTER //
// ./src/router/router.info.js